import { render, staticRenderFns } from "./ColorBubble.vue?vue&type=template&id=5c007697&scoped=true&"
import script from "./ColorBubble.vue?vue&type=script&lang=js&"
export * from "./ColorBubble.vue?vue&type=script&lang=js&"
import style0 from "./ColorBubble.vue?vue&type=style&index=0&id=5c007697&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../store-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c007697",
  null
  
)

export default component.exports